type CampaignCreationGetATSJobIdProps = {
  atsJobId: string | null;
  candidateBatchStatuses: string[] | null;
  csvS3Key: string | null;
  atsListId: string | null;
};

// NOTE: We prevent the ATSJobID from being used when cases are met otherwise the webhook will pick it up and try contact incorrect candidates.
export const campaignCreationGetATSJobId = ({
  atsJobId,
  candidateBatchStatuses,
  csvS3Key,
  atsListId
}: CampaignCreationGetATSJobIdProps): string | null => {
  if (candidateBatchStatuses && candidateBatchStatuses.length > 0) {
    return null;
  }

  if (csvS3Key) {
    return null;
  }

  if (atsListId) {
    return null;
  }

  return atsJobId;
};
